const actionsTypesMyPerson = {
    LOAD_SUCCESS_PERSON:"LOAD_SUCCESS_PERSON",
    LOAD_FAILURE_PERSON:"LOAD_FAILURE_PERSON",
    LOADING_PERSON:"LOADING_PERSON",
}

export default actionsTypesMyPerson